import { action, computed, observable, makeAutoObservable } from 'mobx';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { HeadlineCarouselDataState } from 'src/AppState/CmsState/HeadlineCarouselDataState/HeadlineCarouselData.state';
import { GameStore } from 'src/domains/casino/state/AppCasino/store/game-store/Game.store';

interface CategoryType {
    key: string;
    name: string;
}
export type CollectionType = 'live-casino' | 'casino' | 'virtuals';

export class HeadlineCarouselState {
    private readonly headlineCarouselStateMap: MobxMapAutoNew<CollectionType, HeadlineCarouselDataState>;

    @observable public collection: CollectionType;

    constructor(private readonly gameStore: GameStore) {
        this.collection = 'casino';

        this.headlineCarouselStateMap = new MobxMapAutoNew(
            (collection: CollectionType): HeadlineCarouselDataState => new HeadlineCarouselDataState(collection)
        );
        makeAutoObservable(this);
    }

    @computed get casinoCategories(): Array<CategoryType> {
        return this.gameStore.casinoCollection.categories
            .filter((c) => c.active)
            .map((c) => {
                return { name: c.name, key: c.id.toString() };
            });
    }

    @computed get liveCasinoCategories(): Array<CategoryType> {
        return this.gameStore.liveCasinoCollection.categories
            .filter((c) => c.active)
            .map((c) => {
                return { name: c.name, key: c.id.toString() };
            });
    }

    @computed get headlineBannersData(): HeadlineCarouselDataState {
        return this.headlineCarouselStateMap.get(this.collection);
    }

    @action onChangeCollection = (collection: CollectionType): void => {
        this.collection = collection;
    };
}
